function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  width: 24,
  height: 24
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.19824,3.52242H5.80176a2.3073,2.3073,0,0,0-2.332,2.332V19.94722a.53032.53032,0,0,0,.90527.375l3.3418-3.34179h10.376A2.30294,2.30294,0,0,0,20.39844,14.999a.52894.52894,0,0,0,.13183-.34961V5.85445A2.3073,2.3073,0,0,0,18.19824,3.52242ZM19.46973,14.331a.531.531,0,0,0-.10645.31836,1.25754,1.25754,0,0,1-1.27051,1.27051H7.49707a.5341.5341,0,0,0-.375.15527l-2.5918,2.59278V5.85445A1.25919,1.25919,0,0,1,5.80176,4.583H18.19824a1.25919,1.25919,0,0,1,1.27149,1.27148ZM16.669,8.82125a.53014.53014,0,0,1-.53028.53027H8.19238a.53028.53028,0,0,1,0-1.06055h7.94629A.53015.53015,0,0,1,16.669,8.82125Zm0,3.28515a.53015.53015,0,0,1-.53028.53028H8.19238a.53028.53028,0,0,1,0-1.06055h7.94629A.53014.53014,0,0,1,16.669,12.1064Z"
});

function SvgTemplates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplates);
export default __webpack_public_path__ + "static/media/templates.1fb0b84b.svg";
export { ForwardRef as ReactComponent };